import { LessonPlanDocumentType, LessonPlanType } from "../../../types/LessonPlan";
import { post } from "../../../utils/axios-config";
import { LESSON_PLANS, LESSON_PLANS_DOCUMENTS } from "../../../utils/constants";

export const createLessonPlan = async (data: LessonPlanType) => {
    return await post<LessonPlanType, string>(LESSON_PLANS, data);
  };

export const createLessonPlanDocument = async (data: LessonPlanDocumentType) => {
  return await post<LessonPlanDocumentType, string>(LESSON_PLANS_DOCUMENTS, data);
};